import React, { useState, useEffect, useRef } from "react";
import { useNavigate, useOutletContext, useLocation } from "react-router-dom";
import useAxiosPrivate from "../hooks/useAxiosPrivate";
import { format } from "date-fns";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Dropdown } from "primereact/dropdown";
import { Button } from "primereact/button";
import { Card } from "primereact/card";
import { Toast } from "primereact/toast";
import { ConfirmDialog, confirmDialog } from "primereact/confirmdialog";

export const ListadoSolicitudesCambioSalario = () => {
  const { selectedNomina } = useOutletContext();
  const [faltas, setFaltas] = useState([]);
  const [first2, setFirst2] = useState(0);
  const [rows2, setRows2] = useState(10);
  const axiosPrivate = useAxiosPrivate();
  const navigate = useNavigate();
const dt = useRef(null);
  const toast = useRef(null);
  const getData = async () => {
    try {
      const response = await axiosPrivate.get("NOM/cambio-salario?nomina=" + selectedNomina.idNomina);
        console.log("Excepciones response:", response.data);
      // Formatear fechaAplicacion y created_at a dd/MM/yyyy
      const data = response.data.map((item) => ({
        ...item,
        fechaAplicacion: item.fechaAplicacion
          ? format(new Date(item.fechaAplicacion), "dd/MM/yyyy")  
          : "N/A", // Manejo de fechas nulas
        created_at: item.created_at
          ? format(new Date(item.created_at), "dd/MM/yyyy HH:mm:ss")  
          : "N/A", // Manejo de fechas nulas
      }));


      //  const data = response.data;
      setFaltas(data);
    } catch (error) {
      console.error("Error al obtener faltas:", error);
    }
  };

  useEffect(() => {
    if (!selectedNomina) return;
    getData();
  }, []);
  useEffect(() => {
    getData();

    if (!selectedNomina) return;
if (!selectedNomina) return;
    getData();

  }, [selectedNomina]);
  const columns = [
    { field: "numero", header: "Número" },
    { field: "nombre", header: "Nombre", sortable: true },
    { field: "salarioSolicitado", header: "Salario solicitado" },
    { field: "observaciones", header: "Observaciones" },
    { field: "fechaAplicacion", header: "Fecha aplicacion" },    
    { field: "periodo", header: "Periodo" },
    { field: "created_at", header: "Fecha de creacion" },
  ];

  const dynamicColumns = columns.map((col) => (
    <Column key={col.field} field={col.field} header={col.header} sortable={col.sortable} />
  ));

  const template2 = {
    layout: "RowsPerPageDropdown CurrentPageReport PrevPageLink NextPageLink",
    RowsPerPageDropdown: (options) => {
      const dropdownOptions = [
        { label: 10, value: 10 },
        { label: 20, value: 20 },
        { label: 50, value: 50 },
      ];

      return (
        <>
          <span className="mx-2">Items por página:</span>
          <Dropdown value={options.value} options={dropdownOptions} onChange={options.onChange} />
        </>
      );
    },
    CurrentPageReport: (options) => (
      <span className="mx-2">
        {options.first} - {options.last} de {options.totalRecords}
      </span>
    )
  };

  const onCustomPage2 = (event) => {
    setFirst2(event.first);
    setRows2(event.rows);
  };
 const handleBack = () => {
    navigate(-1);
  };

   const handleEdit = (empleado) => {
      console.log("Editar:", empleado);
      // Aquí podrías navegar a un formulario o abrir un modal
      navigate(`/cambio-salario/${empleado._id}`); // ajusta según tu ruta
    };
  
    const handleDelete = (excepcion) => {
      confirmDialog({
        message: `¿Estás seguro de eliminar el registro de "${excepcion.nombre}"?`,
        header: "Confirmar eliminación",
        icon: "pi pi-exclamation-triangle",
        acceptLabel: "Sí, eliminar",
        rejectLabel: "Cancelar",
        accept: async () => {
          try {
            await axiosPrivate.delete(`/NOM/cambio-salario/${excepcion._id}`);
            toast.current.show({
              severity: "success",
              summary: "Eliminado",
              detail: `Registro eliminado correctamente`,
              life: 3000,
            });
            getData(); // Recargar empleados
          } catch (error) {
            console.error("Error al eliminar:", error);
            toast.current.show({
              severity: "error",
              summary: "Error",
              detail: "No se pudo eliminar el empleado",
              life: 3000,
            });
          }
        },
      });
    };
  


   const actionBodyTemplate = (rowData) => {
      return (
        <div className="flex gap-2">
          <Button
            icon="pi pi-pencil"
            className="p-button-rounded p-button-info p-button-sm"
            onClick={() => handleEdit(rowData)}
            tooltip="Editar"
          />
          <Button
            icon="pi pi-trash"
            className="p-button-rounded p-button-danger p-button-sm"
            onClick={() => handleDelete(rowData)}
            tooltip="Eliminar"
          />
        </div>
      );
    };
  return (
    <div className="p-m-4">
      <Toast ref={toast} />
            <ConfirmDialog />
      <Card title="Listado de solicitudes de cambio de salario">
        <div className="mb-3 flex justify-content-between">
                    <Button
                      label="Regresar"
                      icon="pi pi-arrow-left"
                      className="p-button-secondary"
                      onClick={handleBack}
                    />
                    <Button
                      label="Agregar un registro"
                      icon="pi pi-list"
                      className="p-button-info"
                      onClick={() => navigate("/cambio-salario")}
                    />
                  </div>
        <DataTable
          value={faltas}
          responsiveLayout="scroll"
          paginator
          paginatorTemplate={template2}
          first={first2}
          rows={rows2}
          onPage={onCustomPage2}
          removableSort
          className="p-datatable-sm"
        >
          {dynamicColumns}
          <Column
                      body={actionBodyTemplate}
                      header="Acciones"
                      style={{ minWidth: "10rem" }}
                    />
        </DataTable>
      </Card>
    </div>
  );
};

export default ListadoSolicitudesCambioSalario;
